if (!customElements.get('lp-halloween-cart')) {
  customElements.define('lp-halloween-cart', class extends HTMLElement {
    connectedCallback() {
      this.copyButton = this.querySelector('[data-cart-offer-copy]');
      this.copyLabel = this.querySelector('[data-cart-offer-copy-label]');
      this.codeNode = this.querySelector('[data-cart-offer-code]');
      this.message = this.querySelector('[data-cart-offer-message]');
      this.hint = this.querySelector('[data-cart-offer-hint]');
      this.feedback = this.querySelector('[data-cart-offer-feedback]');
      this.originalLabel = this.copyLabel.textContent;
      this.dateFormat = new Intl.DateTimeFormat('en-US', { month: 'short', day: 'numeric', timeZone: 'America/Los_Angeles' });
      this.onCopy = () => this.copyCode();
      this.onSectionLoad = () => this.syncOffer();
      this.copyButton.addEventListener('click', this.onCopy);
      document.addEventListener('shopify:section:load', this.onSectionLoad);
      this.observer = new MutationObserver(() => this.syncOffer());
      this.source = null;
      this.syncOffer();
      this.interval = window.setInterval(() => this.syncOffer(), 1000);
    }
    disconnectedCallback() {
      window.clearInterval(this.interval);
      window.clearTimeout(this.feedbackTimeout);
      this.observer?.disconnect();
      this.copyButton?.removeEventListener('click', this.onCopy);
      document.removeEventListener('shopify:section:load', this.onSectionLoad);
    }
    syncOffer() {
      const source = document.querySelector('lp-halloween-offer');
      if (source !== this.source) {
        this.observer.disconnect();
        this.source = source;
        if (source) this.observer.observe(source, { attributes: true, attributeFilter: ['data-phase', 'data-start', 'data-end-seconds', 'data-copy-code', 'data-editor-phase', 'style'] });
      }
      if (!source) { this.hidden = true; return; }
      const start = Date.parse(source.dataset.start);
      const end = Number(source.dataset.endSeconds) * 1000;
      const code = source.dataset.copyCode?.trim();
      if (!Number.isFinite(start) || !Number.isFinite(end) || end <= start || !code) { this.hidden = true; return; }
      const now = Date.now();
      let phase = now < start ? 'upcoming' : now < end ? 'active' : 'ended';
      if (window.Shopify?.designMode && ['upcoming', 'active', 'ended'].includes(source.dataset.editorPhase)) phase = source.dataset.editorPhase;
      this.dataset.phase = phase;
      this.hidden = phase === 'ended';
      if (this.hidden) return;
      const template = this.dataset[`${phase}Message`];
      const message = template.replaceAll('[start]', this.dateFormat.format(start)).replaceAll('[end]', this.dateFormat.format(end - 1));
      if (this.message.textContent !== message) this.message.textContent = message;
      const hint = this.dataset[`${phase}Hint`];
      if (this.hint.textContent !== hint) this.hint.textContent = hint;
      if (this.codeNode.textContent !== code) this.codeNode.textContent = code;
      this.copyButton.disabled = false;
      this.copyButton.setAttribute('aria-label', this.dataset.copyLabel.replaceAll('[code]', code));
      const colors = { '--lp-cart-orange': '--lp-hw-bg', '--lp-cart-purple': '--lp-hw-ink', '--lp-cart-cream': '--lp-hw-code-bg' };
      for (const [target, key] of Object.entries(colors)) {
        const value = source.style.getPropertyValue(key).trim();
        if (value && this.style.getPropertyValue(target) !== value) this.style.setProperty(target, value);
      }
    }
    async copyCode() {
      const code = this.codeNode.textContent;
      if (this.hidden || !code) return;
      let copied = false;
      if (navigator.clipboard?.writeText) { try { await navigator.clipboard.writeText(code); copied = true; } catch {} }
      if (!copied) {
        const input = document.createElement('textarea');
        input.value = code;
        input.style.cssText = 'position:fixed;left:-9999px;top:0;';
        input.setAttribute('readonly', '');
        document.body.append(input);
        input.select();
        try { copied = document.execCommand('copy'); } catch {}
        input.remove();
        this.copyButton.focus({ preventScroll: true });
      }
      if (!this.isConnected) return;
      window.clearTimeout(this.feedbackTimeout);
      this.feedback.textContent = copied ? this.dataset.copied : this.dataset.copyFailed;
      this.copyLabel.textContent = copied ? this.dataset.copied : this.originalLabel;
      this.feedbackTimeout = window.setTimeout(() => { this.copyLabel.textContent = this.originalLabel; this.feedback.textContent = ''; }, 2500);
    }
  });
}
